import React, { useState, useEffect } from "react";
import { Column, DataGrid, Button } from "devextreme-react/data-grid";
import { api_path } from "../../shared";
import CustomStore from "devextreme/data/custom_store";
const CustomerLastShipmentByCustomer = ({ CUSTOMER_NAME }) => {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = api_path + "/customer/last-shipment.php";
  const [detailDataSource, setDetailDataSource] = useState(null);
  useEffect(() => {
    if (CUSTOMER_NAME) {
      console.log("Fetch URL:", `${url}?customer_name=${CUSTOMER_NAME}`);
      const store = new CustomStore({
        key: "DOCNO",
        load: () => {
          return fetch(
            `${url}?customer_name=${encodeURIComponent(CUSTOMER_NAME)}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .catch((error) => {
              console.error("Error loading data:", error);
              return [];
            });
        },
      });
      setDetailDataSource(store);
    }
  }, [CUSTOMER_NAME]);

  return (
    <div className="">
      <br />
      <div className="headSubject">
        Last 10 Shipments of The Customer 
        {/* {(CUSTOMER_NAME &&
  ({CUSTOMER_NAME})
        )} */}
      
      </div>
      <DataGrid
        dataSource={detailDataSource}
        showBorders={false}
        keyExpr="DOCNO"
      >
        <Column dataField="SINO_BU" caption="BU" width={50} />
        <Column dataField="SALENAME" caption="Sales" />
        <Column dataField="DOCNO" />
        <Column dataField="JOBNO" />
        <Column dataField="EXPORTER" caption="Customer" />
        <Column dataField="EXPORTERNAME" caption="Exporter" />
        <Column dataField="CHGTERM" width={50} />
        <Column dataField="LOADPORT" caption="POL" width={50} />
        <Column dataField="DISPORT" caption="POD" width={50} />
        <Column dataField="DELPORT" caption="DEL" width={50} />
        <Column dataField="ETDETA" caption="ETD/ETA"         dataType="datetime"
            format="dd-MMM-yyyy"/>
      </DataGrid>
    </div>
  );
};

export default CustomerLastShipmentByCustomer;
